const sexOptions = ["男性", "女性", "その他", "回答しない"] as const;

export default sexOptions;
